// extracted by mini-css-extract-plugin
export default {"select-item-style":"UserRoleDetailsContainer_select-item-style__lwIG3"};